import { PocketHistory } from "@services/dtos/finance.dto";
import { useThemeStore } from "@stores/theme.store";
import { useDetailState } from "@utils/detail_state";
import { toRp } from "@utils/helper";
import { linkPage } from "@utils/router";
import moment from "moment";
import { useEffect } from "react";

export const PocketHistoryDetailPage = () => {
  const state = useDetailState<PocketHistory>(linkPage.FINANCE_POCKET);
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Transaksi",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Transaksi", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  if (!state) return null;

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal Transaksi</div>
        <div className="color-theme mb-3">
          {state?.updateAt != null
            ? moment(state!.updateAt).format("DD MMMM YYYY")
            : "-"}
        </div>
        <div className="color-highlight">ID Transaksi</div>
        <div className="color-theme mb-3">{state?.trxId}</div>
        <div className="color-highlight">Tipe Transaksi</div>
        <div className="color-theme mb-3">
          {state?.filter === "IN" ? "Uang Masuk" : "Uang Keluar"}
        </div>
        <div className="color-highlight">Nominal Transaksi</div>
        <div className="color-theme mb-3">{toRp(state?.nominal ?? 0)}</div>
        <div className="color-highlight">Catatan</div>
        <div className="color-theme mb-3">{state?.description ?? "-"}</div>
      </div>
    </div>
  );
};
